// extracted by mini-css-extract-plugin
export var closeButton = "_14-1";
export var container = "_14-0";
export var fullModalImage = "_14-2";